import { render, staticRenderFns } from "./ProductSalesPageUploader.vue?vue&type=template&id=2fa42e3a&scoped=true&"
import script from "./ProductSalesPageUploader.vue?vue&type=script&lang=ts&"
export * from "./ProductSalesPageUploader.vue?vue&type=script&lang=ts&"
import style0 from "./ProductSalesPageUploader.vue?vue&type=style&index=0&id=2fa42e3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa42e3a",
  null
  
)

export default component.exports